import { isValueNumber } from './typeValidators';
export const getMonetaryValue = value => isValueNumber(value) ? "$".concat(parseFloat(value).toFixed(2)) : 'N/A';